// extracted by mini-css-extract-plugin
export default {"videoWrapper":"video-viewer_videoWrapper__Mt366","overview":"video-viewer_overview__qhyBt","playerContainer":"video-viewer_playerContainer__EZNII"};